import * as types from 'misc/types';
import * as actions from 'misc/actions';

const tags = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_TAGS_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_TAGS_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_TAGS_GET.FAILURE:
            return actions.error(state, action.error);
        default:
            return state;
    }
};

export default tags;



// WEBPACK FOOTER //
// ./src/reducers/tags.js